var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 219,
    viewBox: "0 0 222 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Procyon",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element 111",
    filter: "url(#filter0_f_847_20388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 103.21,
    cy: 103.21,
    r: 52.2105,
    fill: "#40BAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Element 110",
    filter: "url(#filter1_f_847_20388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.743,
    cy: 126.647,
    r: 41.9842,
    fill: "#AD7FF9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Element 109",
    filter: "url(#filter2_f_847_20388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 138.708,
    cy: 91.5453,
    r: 32.7218,
    fill: "#FFA4FB",
    fillOpacity: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_847_20388",
    x: 0.905312,
    y: 0.905312,
    width: 204.61,
    height: 204.61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.0473,
    result: "effect1_foregroundBlur_847_20388"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_847_20388",
    x: 24.6643,
    y: 34.5684,
    width: 184.158,
    height: 184.158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.0473,
    result: "effect1_foregroundBlur_847_20388"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_847_20388",
    x: 55.8919,
    y: 8.72878,
    width: 165.633,
    height: 165.633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.0473,
    result: "effect1_foregroundBlur_847_20388"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamBg);
export default __webpack_public_path__ + "static/media/team-bg.341956daba06e5fe6d19cfc8b8319de5.svg";
export { ForwardRef as ReactComponent };